import {SPINNER} from "../../../constants";
import {AbstractDelete} from "../../../clone/dialog/delete";
import {nsFa} from "../../fa/fn";
import i = nsFa.i;
import {nsSynchronizationTemplateClone} from "../../../clone/nsSynchronizationTemplateClone";

export {template} from "../../../clone/dialog/delete";

export class viewModel extends AbstractDelete {

    protected readonly EVENT_SUCCESS : string = "exporttemplate.delete.success";

    protected override process(): Promise<any> {
        return nsSynchronizationTemplateClone.trash(this.params.item);
    }

}
